import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export function captureError(err: any) {
  const msg = err.url ? `${err.url}\n${err.message}` : err.message;
  if (process.env.NODE_ENV === 'development') {
    console.trace('capture err: ', msg);
  }
  Sentry.captureMessage(msg || err.toString());
}

/**
 * 
export function traceSpan(name, fn) {
  const span = Sentry.startSpan({ name });
  try {
    return fn();
  } finally {
    span.end();  // <-- 结束时 Sentry 自动计算耗时
  }
}
内部逻辑：

1. startSpan() 会记录一个 startTime = now()
2. 执行你传入的回调函数
3. span.end() 会记录 endTime = now()

Sentry 自动计算：
span.duration = endTime - startTime
 */

/**
 * 统一 startSpan，自动挂到当前 active transaction
 */
export function traceSpan<T>(name: string, fn: () => T | Promise<T>): T | Promise<T> {
  return Sentry.startSpan({ name }, fn);
}

/**
 * 支持 async/await
 */
export async function traceAsync<T>(name: string, fn: () => Promise<T>): Promise<T> {
  return await Sentry.startSpan({ name }, fn);
}

// 手动测量，React 组件耗时
export function useRenderTrace(name: string) {
  const start = performance.now();

  useEffect(() => {
    const end = performance.now();
    const duration = end - start;

    Sentry.startSpan(
      {
        name: `Render:${name}`,
        op: 'component.render',
        data: { duration },
      },
      () => {},
    );
  });
}

export function useSentryContext(userInfo: any, siteConfig: any) {
  // 在组件中添加 useEffect
  useEffect(() => {
    // 设置用户上下文(可选,但推荐)
    if (userInfo) {
      Sentry.setUser({
        id: String(userInfo.sysNo || ''),
        username: userInfo.name,
      });
    } else {
      Sentry.setUser(null);
    }

    // 设置全局标签(可选)
    Sentry.setTags({
      tenant: (siteConfig as any)?.tenantCode,
      app: 'mall-fe',
    });
  }, [userInfo, siteConfig]);
}
